<script>

    import Moment from 'moment'
    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import DateRangeNav from '../$components/date.range.nav.svelte'
    import ShipmentsCard from './component.shipments.card.svelte'
    import ShipmentsCanceledCard from './component.shipments.canceled.card.svelte'
    import ShipmentsFinalpriceCard from './component.shipments.finalprice.card.svelte'
    import ShipmentsShipmentcostCard from './component.shipments.shipmentcost.card.svelte'
    import ShipmentsProvidersTopCard from './component.shipments.providers.top.card.svelte'
    import ShipmentsClientsTopCard from './component.shipments.clients.top.card.svelte'
    import CreditsLatestCard from './component.credits.latest.card.svelte'
    import CreditsUsersTopCard from './component.credits.users.top.card.svelte'
    import ChargesCard from './component.charges.card.svelte'
    import ChargesPendingCard from './component.charges.pending.card.svelte'
    import ChargesUsersTopCard from './component.charges.users.top.card.svelte'
    import ChargesRefundsUsersTopCard from './component.charges.refunds.users.top.card.svelte'
    import ShipmentsGraphic from './component.shipments.graphic.svelte'
    import ChargesGraphic from './component.charges.graphic.svelte'
    import ShipmentsMap from './component.shipments.map.svelte'

    if (!isPermission($adminStore, 'GraphicsView'))
        replace('/404')

    let dateStart = Moment().startOf('month').startOf('day').toDate()
    let dateEnd = Moment().endOf('month').endOf('day').toDate()

</script>

<style>
    .graphics-toolbar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1.25rem;
    }

    .stats-grid :global(.stats-card),
    .tops-grid :global(.stats-card) {
        height: 100%;
    }
</style>

<View>
    <PageHeader title="Gráficas" subtitle="Estadísticas y métricas de la plataforma" />

	<ShipmentsGraphic />
    <ShipmentsMap />

    <div class="graphics-toolbar">
        <DateRangeNav bind:dateStart bind:dateEnd />
    </div>
    <div class="columns is-multiline is-mobile is-variable is-5 stats-grid mb-5">
        <div class="column is-full-mobile is-half-tablet">
            <ShipmentsCard {dateStart} {dateEnd} />
        </div>
        <div class="column is-full-mobile is-half-tablet">
            <ShipmentsCanceledCard {dateStart} {dateEnd} />
        </div>
        <div class="column is-full-mobile is-half-tablet">
            <ShipmentsFinalpriceCard {dateStart} {dateEnd} />
        </div>
        <div class="column is-full-mobile is-half-tablet">
            <ShipmentsShipmentcostCard {dateStart} {dateEnd} />
        </div>
    </div>
    <div class="columns is-multiline is-mobile is-variable is-5 tops-grid mb-5">
        <div class="column is-full-mobile is-half-tablet">
			<ShipmentsClientsTopCard {dateStart} {dateEnd} />
        </div>
        <div class="column is-full-mobile is-half-tablet">
			<ShipmentsProvidersTopCard {dateStart} {dateEnd} />
        </div>
    </div>
    <div class="columns is-multiline is-mobile is-variable is-5 tops-grid mb-5">
        <div class="column is-full-mobile is-half-tablet">
			<CreditsUsersTopCard {dateStart} {dateEnd} />
        </div>
        <div class="column is-full-mobile is-half-tablet">
			<CreditsLatestCard {dateStart} {dateEnd} />
        </div>
    </div>
    <div class="columns is-multiline is-mobile is-variable is-5 tops-grid mb-5">
        <div class="column is-full-mobile is-half-tablet">
            <ChargesRefundsUsersTopCard {dateStart} {dateEnd} />
        </div>
    </div>

	<ChargesGraphic />
</View>
